<!-- 视频播放 -->
<!-- https://github.com/surmon-china/vue-video-player/blob/master/examples/01-video.vue -->
<template>
	<div class="video-player-wrapper">
		<video-player :playsinline="true" :options="playerOptions" @ended="onPlayerEnded($event)" @timeupdate="onPlayerTimeupdate" ref="videoPlayerRef"
                  />
	</div>
</template>

<script>
	import utils from "@/components/tools/utils.js";
	import { videoPlayer } from 'vue-video-player';
    import 'video.js/dist/video-js.css';
	export default {
		name: 'ResourceVideoPlayer',
		data() {
			return {
                // 视频播放属性
                playerOptions: {
                    playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                    autoplay: true, // 自动播放
                    muted: false, // 静音
                    loop: false, // 循环播放
                    preload: "auto", // 预加载
                    language: 'zh-CN',
                    sources: [{
                        type: "video/mp4",
                        src: "", // 源文件路径
                    }],
                    poster: "", // 封面地址
                    notSupportedMessage: '此视频暂无法播放，请稍后再试', // 覆盖Video.js无法播放媒体源时显示的默认信息。
                    controlBar: {
                        timeDivider: true,
                        durationDisplay: true,
                        remainingTimeDisplay: true,
                        fullscreenToggle: true  //全屏按钮
                    },
                },
                currentFullScreen:false
			};
		},
		props: [ 'resource' ],
		components: { videoPlayer },
		methods: {
			// 文件播放路径
			getPlayPath(path) {
				return utils.getPlayPath(path);
			},
      onPlayerEnded(player) {
        this.$emit('close');
      },
      onPlayerTimeupdate() {
        // 通过 ref 获取视频播放器实例
        const player = this.$refs.videoPlayerRef.player;
        // 获取当前暂停的时间点
        let playerTime = player.currentTime();
        console.log(Math.floor(playerTime));
        this.$emit('checkOpenExer',Math.floor(playerTime))
      },
      pause(){
        const player = this.$refs.videoPlayerRef.player;
        player.pause();
        if (player.isFullscreen()) {
          this.currentFullScreen = true
          player.exitFullscreen();
        }
      },
      playVideo(time){
        const player = this.$refs.videoPlayerRef.player;
        player.currentTime(time + 1);
        player.play();
        if(this.currentFullScreen) {
          player.requestFullscreen();
        }

      },
    },
    mounted() {
      const player = this.$refs.videoPlayerRef.player;
      player.on('fullscreenchange', function () {
        if (this.isFullscreen()) {
          this.currentFullScreen = true
          console.log('播放器已进入全屏模式');
        } else {
          this.currentFullScreen = false
          console.log('播放器已退出全屏模式');
        }
      });
    },
    created(){
			this.playerOptions.poster = this.getPlayPath(this.resource.thumbPath);
            this.playerOptions.sources[0].src = this.getPlayPath(this.resource.path);
            if(this.subfix == 'mp4') this.playerOptions.sources[0].type = 'video/mp4';
            if(this.subfix == 'mp3') this.playerOptions.sources[0].type = 'audio/mpeg';
		}
	}
</script>
<style lang="scss">
    @import "@/assets/scss/common.scss";
    @import "@/assets/scss/common/resource/player/resource-video-player.scss";
</style>



// WEBPACK FOOTER //
// src/components/common/resource/player/resource-video-player.vue